<span class="row-index" *ngIf="!params.node.isSelected()">
    {{ params.node.rowIndex + 1 }}
</span>

<mat-checkbox class="row-checkbox" color="primary" [checked]="params.node.isSelected()"
    (change)="onCheckboxChange($event)">
</mat-checkbox>